import { useState } from "react";
import Reveal from "@/components/base/Reveal";
import { faqItems } from "@/mocks/siteContent";

export default function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section id="faq" className="scroll-mt-20 w-full bg-background-50">
      <div className="w-full px-4 md:px-8 lg:px-12 py-14 md:py-20">
        <Reveal>
          <div className="flex items-center gap-3 mb-3">
            <span className="h-px w-8 bg-primary-400"></span>
            <span className="font-label text-xs md:text-sm tracking-widest text-primary-600 uppercase">
              FAQ
            </span>
          </div>
          <h2 className="font-heading font-bold text-foreground-950 text-2xl md:text-4xl">
            常见问题
          </h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base max-w-3xl leading-relaxed">
            关于本站内容范围、资料查询方式与信息可信度的常见疑问，集中回答在这里。
          </p>
        </Reveal>

        <div className="mt-10 max-w-4xl">
          <div className="space-y-3">
            {faqItems.map((item, i) => {
              const isOpen = open === i;
              return (
                <Reveal key={item.q} delay={i * 40}>
                  <div className="rounded-xl border border-background-200 bg-background-50 overflow-hidden">
                    <button
                      type="button"
                      aria-expanded={isOpen}
                      onClick={() => setOpen(isOpen ? null : i)}
                      className="w-full flex items-center justify-between gap-4 px-4 md:px-5 py-4 text-left cursor-pointer hover:bg-background-100 transition-colors"
                    >
                      <span className="flex items-start gap-3">
                        <span className="font-heading font-bold text-primary-500 text-sm md:text-base mt-0.5">
                          Q{i + 1}
                        </span>
                        <span className="text-sm md:text-base font-medium text-foreground-950">
                          {item.q}
                        </span>
                      </span>
                      <i
                        className={`shrink-0 text-lg text-foreground-500 transition-transform duration-300 ${
                          isOpen ? "ri-subtract-line" : "ri-add-line"
                        }`}
                      ></i>
                    </button>
                    {isOpen && (
                      <div className="px-4 md:px-5 pb-4 pl-4 md:pl-12">
                        <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                          {item.a}
                        </p>
                      </div>
                    )}
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}